import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import ProcessedResult from './report-generation-module/ProcessedResult';
import DownloadPdf from './report-generation-module/DownloadPdf';
import { FullscreenProvider } from './context/FullScreenContext';
import ProtectedRoute from './protected-route/ProtectedRoute';
import NoAccess from './protected-route/NoAccess';
import StartInspectionRetake
  from './camera-module/instructions-module/StartInspectionRetake';
import StartInspection
  from './camera-module/instructions-module/StartInspection';
import VideoInstruction
  from './video-module/instructions-module/VideoInstruction';
// import ViewAudit from "./view-audit/ViewAudit";
import Inspection from './audit-creation-module/Inspection';
// import CameraModuleUpdated from "./components/imageCategories/UpdatedCameraCopy";
import Login from './login-module/login';
import CameraModule from './camera-module/Camera';
import CameraModuleRetake from './camera-module/CameraRetake';
import ImageAnalyzer from './components/TestCams/ImageTester';

import SuccessComponent from './audit-completion-module/SuccessComponent';
import SuccessfulComponent from './audit-completion-module/SuccessfulComponent';
import Permission from './camera-module/location-camera-permission/Permission';
import PermissionRetake from './camera-module/location-camera-permission/PermissionRetake';
import VideoRecorder from './video-module/VideoModule';

import Processing from './audit-completion-module/Processing';
import ProcessingRetake from './audit-completion-module/ProcessingRetake';
import TestCache from './components/TestCams/TestCache';
import InternetSignal from './components/TestCams/InternetSignal';
import InspectionMethod
  from './audit-creation-module/inspection-mode/InspectionMethod';
import PermissionVideo
  from './video-module/location-camera-audio-permission/Permission';
import StartInspectionVideo
  from './video-module/instructions-module/StartInspection';
import VideoTimer from './video-module/video-timer/VideoTimer';
import ProcessingVideo
  from './audit-completion-module/video-module-completion/Processing';
import ShareAuditOptions from './components/TestCams/ShareAuditOptions';
import ShareOptions from './components/TestCams/ShareAuditOptions';
import WebcamVideo from './components/TestCams/ImageTester';
import Photo_Video_Instruction
  from './camera-module/photo_video_instruction/Photo_Video_Instruction';
import SpeedTest from './components/TestCams/NetworkCheck';
import DynamicResolutionWebcam from './components/TestCams/NetworkCheck';
import PermissionHybrid
  from './hybrid-mode-module/location-camera-permission/Permission';
import StartInspectionHybrid
  from './hybrid-mode-module/instructions-module/StartInspection';
import CameraModuleHybrid from './hybrid-mode-module/Camera';
import ProcessingHybrid
  from './audit-completion-module/hybrid-module-completion/Processing';
import AuditCreation from './audit-creation-module/AuditCreation';
import ModeProtectedRoute from './protected-route/ModeProtectedRoute';
import RetakeStatusGuard from './protected-route/RetakeStatusGuard '
import Introduction from './intro-module/Introduction'
import AuditList from './intro-module/AuditList'
import AuditDescription from './intro-module/AuditDescription';
import UserType from './nativeHelperComponents/userType';
import InputLink from './nativeHelperComponents/pasteLinkComponent';
import ForgotPassword from './login-module/ForgotPassword';
import ResetPassword from './login-module/ResetPassword';
import PasswordResetForm from './login-module/NewPassword';
import WebcamCapture from './test_CAM/a55issue';
// import LocationPermission from "./instructions-module/LocationPermission";
function App() {
  return (
    <Router>
      <FullscreenProvider>
        <Routes>

          {/* generic routes for video & photo mode */}
          <Route path="/" element={<UserType />} />
          <Route path="/userType" element={<UserType />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auditList" element={<AuditList />} />
          <Route path="/auditDescription" element={<AuditDescription />} />
          <Route path="/home" element={<Inspection />} />
          {/* <Route path="/view-audit" element={<ViewAudit />} /> */}
          <Route
            exact
            path="/audit/inspection/mode/:audit_id"
            element={<ModeProtectedRoute element={InspectionMethod} />}
          />

          {/* photo mode routes */}
          <Route
            exact
            path="/audit/photo/permission/:audit_id"
            element={<ProtectedRoute element={Permission} />}
          />
          <Route
            exact
            path="/audit/photoretake/permission/:audit_id"
            element={
              <RetakeStatusGuard>
                <PermissionRetake />
              </RetakeStatusGuard>
            }
          />

          <Route
            exact
            path="/audit/photo/:audit_id"
            element={<ProtectedRoute element={StartInspection} />}
          />
          <Route
            path="/audit/photoretake/:audit_id"
            element={
              <RetakeStatusGuard>
                <StartInspectionRetake />
              </RetakeStatusGuard>
            }
          />
          <Route path="/camera/:audit_id" element={<CameraModule />} />
          {/* <Route path="/cameraretake/:audit_id" element={<CameraModuleRetake />} /> */}

          <Route
            path="/cameraretake/:audit_id"
            element={
              <RetakeStatusGuard>
                <CameraModuleRetake />
              </RetakeStatusGuard>
            }
          />

          {/* video mode routes */}
          <Route
            exact
            path="/audit/video/permission/:audit_id"
            element={<ProtectedRoute element={PermissionVideo} />}
          />
          <Route
            exact
            path="/audit/video/:audit_id"
            element={<ProtectedRoute element={StartInspectionVideo} />}
          />
          <Route
            path="/video_intructions/:audit_id"
            element={<VideoInstruction />}
          />
          <Route path="/video/:audit_id" element={<VideoRecorder />} />
          <Route path="/videoTimer" element={<VideoTimer number={3} />} />
          <Route
            path="/processing/video/:audit_id"
            element={<ProcessingVideo />}
          />

          {/* hybrid mode route */}
          <Route
            exact
            path="/audit/hybrid/permission/:audit_id"
            element={<ProtectedRoute element={PermissionHybrid} />}
          />
          <Route
            exact
            path="/audit/hybrid/:audit_id"
            element={<ProtectedRoute element={StartInspectionHybrid} />}
          />
          <Route path="/camera-hybrid/:audit_id" element={<CameraModuleHybrid />} />
          <Route
            path="/processing/hybrid/:audit_id"
            element={<ProcessingHybrid />}
          />
          {/* report generation route */}
          <Route path="/auditInfo/:audit_id" element={<DownloadPdf />} />

          {/* generic route to create new audit*/}
          <Route
            exact
            path="/audit/inspection/:audit_id"
            element={<AuditCreation />}
          />
          <Route
            exact
            path="/forgot-password"
            element={<ForgotPassword />}
          />
          <Route
            exact
            path="/reset-password"
            element={<ResetPassword />}
          />
          <Route
            exact
            path="/Set-NewPassword"
            element={<PasswordResetForm />}
          />

          {/* Generic Routes */}

          <Route path="/no-access" element={<NoAccess />} />
          {/* audit completion route */}
          <Route path="/processing/:audit_id" element={<Processing />} />
          {/* <Route path="/processingretake/:audit_id" element={<ProcessingRetake />} /> */}

          <Route
            path="/processingretake/:audit_id"
            element={
              <RetakeStatusGuard>
                <ProcessingRetake />
              </RetakeStatusGuard>
            }
          />
          <Route path="/success" element={<SuccessComponent />} />
          <Route path="/successful/:audit_id" element={<SuccessfulComponent />} />

          {/* test routes */}
          <Route exact path="/testing" element={<DynamicResolutionWebcam />} />
          {/* <Route path="/test" element={<ShareOptions url ="https://insurance-inspection.cainatics.in/"/>} /> */}
          {/* <Route path="/test" element={<MyComponent/>} /> */}
          <Route path="/test1" element={<AuditCreation />} />
          <Route path="/test2" element={<WebcamCapture />} />

        </Routes>
      </FullscreenProvider>
    </Router>
  );
}

export default App;
